const User = {
    id: null,
    name: '',
    email: '',
    group: ''
}

export default User